import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import AsegoBookingService from "./AsegoBookingService.js";


export const getAsegoBookings = createAsyncThunk("AsegoBooking/get-AsegoBookings", async (thunkAPI) => {
    try {
        return await AsegoBookingService.getAsegoBookings();
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const createAsegoBooking = createAsyncThunk(
    "AsegoBooking/create-AsegoBookings",
    async (AssociationData, thunkAPI) => {
        try {
            return await AsegoBookingService.createAsegoBooking(AssociationData);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getAsegoBooking = createAsyncThunk(
    "AsegoBooking/get-AsegoBooking",
    async (id, thunkAPI) => {
        try {
            return await AsegoBookingService.getAsegoBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateAsegoBooking = createAsyncThunk(
    "AsegoBooking/update-AsegoBooking",
    async (id, thunkAPI) => {
        try {
            return await AsegoBookingService.updateAsegoBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteAsegoBooking = createAsyncThunk(
    "AsegoBooking/delete-AsegoBooking",
    async (id, thunkAPI) => {
        try {
            return await AsegoBookingService.deleteAsegoBooking(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateAsegoBookingStatus = createAsyncThunk(
    "AsegoBooking/update-AsegoBooking-status",
    async (id, thunkAPI) => {
        try {
            return await AsegoBookingService.updateAsegoBookingStatus(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const resetState = createAction("Reset_all");

const initialState = {
    AsegoBookings: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};
export const AsegoBookingSlice = createSlice({
    name: "AsegoBooking",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAsegoBookings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAsegoBookings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.AsegoBookings = action.payload.data;
            })
            .addCase(getAsegoBookings.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(createAsegoBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createAsegoBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.createdAsegoBooking = action.payload;
            })
            .addCase(createAsegoBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.payload;
            })

            .addCase(getAsegoBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAsegoBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.chaptersname = action.payload.data.name;
                state.chapterspost = action.payload.data.post;
                state.chaptersabout = action.payload.data.about;
            })
            .addCase(getAsegoBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateAsegoBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateAsegoBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedAsegoBooking = action.payload;
            })
            .addCase(updateAsegoBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(deleteAsegoBooking.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteAsegoBooking.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.deletedAsegoBooking = action.payload;
            })
            .addCase(deleteAsegoBooking.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateAsegoBookingStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateAsegoBookingStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedAsegoBookingStatus = action.payload;
            })
            .addCase(updateAsegoBookingStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(resetState, () => initialState);
    },
});
export default AsegoBookingSlice.reducer;
